"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteAttendeeManager = void 0;
const streem_logger_1 = require("../util/streem_logger");
const video_tracks_1 = require("../tracks/video_tracks");
const data_tracks_1 = require("../tracks/data_tracks");
const volume_indicator_callback_1 = require("../observers/volume_indicator_callback");
const constants_1 = require("../util/constants");
class RemoteAttendeeManager {
    constructor(localAttendeeId, audioVideoFacade, onRemoteAudioLevelUpdate, onRemoteSignalStrengthUpdate, onRemoteAttendeeAdded, onRemoteAttendeeRemoved) {
        this.localAttendeeId = localAttendeeId;
        this.audioVideoFacade = audioVideoFacade;
        this.onRemoteAudioLevelUpdate = onRemoteAudioLevelUpdate;
        this.onRemoteSignalStrengthUpdate = onRemoteSignalStrengthUpdate;
        this.onRemoteAttendeeAdded = onRemoteAttendeeAdded;
        this.onRemoteAttendeeRemoved = onRemoteAttendeeRemoved;
        this.logger = streem_logger_1.streemLogger.extend('sdk-chime-video:RemoteAttendeeManager');
        this.remoteAttendees = [];
    }
    getOrCreateAttendee(attendeeId, externalUserId) {
        const attendee = this.getAttendeeById(attendeeId);
        if (attendee) {
            this.logger.debug(`Found existing attendee with attendeeId: ${attendee.attendeeId} and userId: ${attendee.externalUserId}, no need to create a new one`);
            return attendee;
        }
        else {
            const createdAttendee = this.createNewAttendee(attendeeId, externalUserId);
            this.logger.debug(`Attendee with attendeeId: ${attendeeId} and userId: ${externalUserId} not found, new attendee created with attendeeId: ${createdAttendee.attendeeId} and userId: ${createdAttendee.externalUserId}`);
            return createdAttendee;
        }
    }
    removeAttendee(attendeeId) {
        const attendee = this.getAttendeeById(attendeeId);
        if (!attendee) {
            this.logger.warn(`Remote attendee not found for attendeeId: ${attendeeId}, already removed`);
            return;
        }
        this.logger.info(`Removing attendee with attendeeId: ${attendeeId} and userId: ${attendee.externalUserId}`);
        this.disconnectAttendee(attendee);
        this.remoteAttendees = this.remoteAttendees.filter(attendee => attendee.attendeeId !== attendee.attendeeId);
    }
    disconnect() {
        this.remoteAttendees.forEach(attendee => this.disconnectAttendee(attendee));
        this.remoteAttendees = [];
    }
    pauseAttendee(attendee) {
        this.logger.warn(`Remote video tile is paused for userId: ${attendee.externalUserId}.  May indicate insufficient bandwidth`);
        attendee.isPaused = true;
        attendee.videoTrack.onPausedChange(true);
    }
    unpauseAttendee(attendee) {
        this.logger.info(`Remote video tile is unpaused for userId: ${attendee.externalUserId}`);
        attendee.isPaused = false;
        attendee.videoTrack.onPausedChange(false);
    }
    updateEnabledStateForAttendeeVideoTrack(attendee, enabled) {
        this.logger.debug(`Remote video track enabled state changed for userId: ${attendee.externalUserId}`);
        attendee.videoTrack.onEnabledChange(enabled);
    }
    removeTileIdFromAttendee(attendee) {
        attendee.tileId = undefined;
    }
    checkIfAttendeeCanBeIgnored(attendeeId, externalUserId) {
        return ((externalUserId === null || externalUserId === void 0 ? void 0 : externalUserId.startsWith(constants_1.AWS_ATTENDEE_PREFIX)) || attendeeId === this.localAttendeeId);
    }
    getAttendeeByTileId(attendeeTileId) {
        return this.remoteAttendees.find(attendee => attendee.tileId === attendeeTileId);
    }
    createNewAttendee(attendeeId, externalUserId) {
        this.logger.info(`Creating new attendee with attendeeId: ${attendeeId} and userId: ${externalUserId}`);
        const volumeIndicatorCallback = (0, volume_indicator_callback_1.createVolumeIndicatorCallback)(attendeeId, this.onRemoteAudioLevelUpdate, this.onRemoteSignalStrengthUpdate);
        const videoTrack = new video_tracks_1.ChimeRemoteVideoTrack(this.audioVideoFacade, externalUserId);
        videoTrack.initializeVideoTrack();
        const newAttendee = {
            attendeeId,
            externalUserId,
            present: true,
            dataTrack: new data_tracks_1.ChimeRemoteDataTrack(this.audioVideoFacade),
            videoTrack,
            volumeIndicatorCallback,
            isPaused: false,
        };
        this.audioVideoFacade.realtimeSubscribeToVolumeIndicator(attendeeId, volumeIndicatorCallback);
        this.remoteAttendees.push(newAttendee);
        this.onRemoteAttendeeAdded(newAttendee);
        return newAttendee;
    }
    disconnectAttendee(attendee) {
        attendee.dataTrack.disconnect();
        attendee.videoTrack.disconnect();
        if (attendee.volumeIndicatorCallback) {
            this.audioVideoFacade.realtimeUnsubscribeFromVolumeIndicator(attendee.attendeeId, attendee.volumeIndicatorCallback);
            attendee.volumeIndicatorCallback = undefined;
        }
        this.onRemoteAttendeeRemoved(attendee);
    }
    getAttendeeById(attendeeId) {
        return this.remoteAttendees.find(attendee => attendee.attendeeId === attendeeId);
    }
}
exports.RemoteAttendeeManager = RemoteAttendeeManager;
//# sourceMappingURL=remote_attendee_manager.js.map